import { NgModule } from "@angular/core";
import { InjectionToken } from "@angular/core";

export const WINDOW = new InjectionToken<Window>("WindowToken");

export function _window(): Window {
  return window;
}

/**
 * Note: used in ./services/bfx-clipboard.service
 */
@NgModule({
  providers: [
    {
      provide: WINDOW,
      useFactory: _window,
    },
  ],
})
export class WindowTokenModule {}
